
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/package-type/[...type]",
      function () {
        return require("private-next-pages/package-type/[...type].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/package-type/[...type]"])
      });
    }
  